/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Resource_ColInputs */

const en_admin_permissions_resource_col = /** @type {(inputs: Admin_Permissions_Resource_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource`)
};

const zh_admin_permissions_resource_col = /** @type {(inputs: Admin_Permissions_Resource_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

/**
* | output |
* | --- |
* | "Resource" |
*
* @param {Admin_Permissions_Resource_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_resource_col = /** @type {((inputs?: Admin_Permissions_Resource_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Resource_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_resource_col(inputs)
	return zh_admin_permissions_resource_col(inputs)
});
export { admin_permissions_resource_col as "admin.permissions.resource_col" }